<template>
  <div class="d-flex justify-end" :class="align">
    <VRating
      v-model="stars"
      :color="ratingColor"
      :hover="true"
      :hover-color="ratingColor"
      dense
      background-color="grey darken-1"
      :size="size"
      :readonly="readonly"
      :half-increments="halfIncrements"
    />
  </div>
</template>

<script>
import Candidate from '../../orm/models/Candidate/Candidate';

export default {
  name: 'CandidateRating',

  props: {
    candidate: {
      type: Object,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 16,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
    align: {
      type: String,
      default: 'align-start',
    },
  },

  computed: {
    isManualRatingSet() {
      return !!this.candidate.rating;
    },

    stars: {
      get() {
        if (this.isManualRatingSet) {
          return this.candidate.rating;
        }

        const ai = this.candidate.interview?.aiRating ?? this.candidate.aiRating;

        if (!ai) { return 0; }

        return ai ? ai / 2 : 0.5;
      },

      async set(value) {
        if (this.readonly) return;

        const newRating = Math.round(value);
        const oldRating = this.candidate.rating;

        await Candidate.update({
          where: this.candidate.id,
          data: { rating: newRating },
        });

        try {
          await Candidate.api().updateRating(this.candidate.id, newRating);
        } catch (e) {
          await Candidate.update({
            where: this.candidate.id,
            data: { rating: oldRating },
          });
          this.$toast.error(e.message);
        }
      },
    },

    halfIncrements() {
      return !this.isManualRatingSet;
    },

    ratingColor() {
      return this.isManualRatingSet ? 'yellow accent-4' : 'blue accent-2';
    },
  },
};

</script>
